export default __webpack_public_path__ + "static/media/RD-logo.3b7a191b.svg";